export default class SearchAutocompleteController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    getText(item) {
        if (this.textKey) {
            return item[this.textKey];
        }
        return item;
    }

    itemSelected() {
        this.onSelected(
            this.eventEmitter({
                item: this.selectedItem
            })
        );
    }

    queryChanged() {
        this.onChange(
            this.eventEmitter({
                query: this.query
            })
        );
    }

    search() {
        return this.onSearch(
            this.eventEmitter({
                query: this.query
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/common/search-autocomplete/autocomplete.controller.js